import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["trackingName", "onClose", "scopes", "loaded", "loader", "dataTestId", "onOpenStart", "onOpenComplete", "onCloseComplete", "rootNode"];
import { useState, useEffect } from 'react';
import createSingleI18nProvider from 'I18n/init/providers/createSingleI18nProvider';
import getLangLocale from 'I18n/utils/getLangLocale';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import QuickInviteModalContainer from './QuickInviteModalContainer';
import { delay } from '../utils/helpers';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncQuickInviteModalContent = Loadable({
  loader: () => import( /* webpackChunkName: "quick-invite-modal" */'../modals/QuickInviteModal/QuickInviteModalContent'),
  LoadingComponent: () => null
});

// Shared cache
let preloaded = false;
let modules;
const getModules = () => {
  if (!modules) {
    modules = [AsyncQuickInviteModalContent.preload(), import(`i2l?query=sporks!growth-invite-components/lang/en.lyaml`).then(module => createSingleI18nProvider({
      language: getLangLocale()
    }).register(module.default))];
  }
  return modules;
};
const AsyncQuickInviteModalContainer = _ref => {
  let {
      trackingName,
      onClose,
      scopes = [],
      loaded = preloaded,
      loader = getModules,
      dataTestId,
      onOpenStart,
      onOpenComplete,
      onCloseComplete,
      rootNode
    } = _ref,
    modalProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [moduleState, setModuleState] = useState(loaded ? 'NOT_LOADED' : 'LOADED');
  useEffect(() => {
    if (loaded) {
      return;
    }
    setModuleState('LOADING');
    const promises = [...loader(), delay(650)];
    Promise.allSettled(promises).then(results => {
      if (results.some((result, index) => result.status === 'rejected' &&
      // `/invite/v3/invites/domain-based` endpoint will 404 when
      // domain invite has never been created
      index !== 3)) {
        setModuleState('ERROR');
      } else {
        setModuleState('LOADED');
      }
    }).catch(err => {
      console.log(err);
    });
  }, [loaded, loader]);

  // Clear cache
  if (moduleState === 'ERROR') {
    preloaded = false;
    modules = [];
  }
  return /*#__PURE__*/_jsx(QuickInviteModalContainer, {
    "data-test-id": dataTestId,
    trackingName: trackingName,
    scopes: scopes,
    onOpenStart: onOpenStart,
    onOpenComplete: onOpenComplete,
    onCloseComplete: onCloseComplete,
    rootNode: rootNode,
    onClose: onClose,
    isLoading: moduleState === 'LOADING',
    hasError: moduleState === 'ERROR',
    children: /*#__PURE__*/_jsx(AsyncQuickInviteModalContent, Object.assign({}, modalProps, {
      trackingName: trackingName,
      scopes: scopes,
      onClose: onClose
    }))
  });
};
AsyncQuickInviteModalContainer.preload = () => {
  Promise.all(getModules()).then(() => {
    preloaded = true;
  }).catch(() => {
    preloaded = false;
  });
};
export default AsyncQuickInviteModalContainer;